import "./Donate.module.css";
import Header from "@/reusable_sections/Header";
import DonateHero from "./sections/DonateHero";
import DonationImpact from "./sections/DonationImpact";
import Footer from "@/reusable_sections/Footer";
export default function DonatePage() {
  return <div>
      <Header />
      <DonateHero />
      <DonationImpact />
      <Footer />
    </div>;
}